/* ========================================================================
   On document ready do stuff
 ========================================================================== */

util.onDocumentReady(function () {
  const body = document.getElementById('body');

  // Set frontend version
  util.frontEndVersion = body.dataset.version;

  // Set debug mode
  util.debugMode = body.dataset.debugMode === 'true';

  // Set culture
  util.uiCulture = body.dataset.culture;

  // Set language
  util.uiLanguage = util.uiCulture ? util.uiCulture.split('-')[0] : null;

  // Set homepage Id
  util.homePageId = body.dataset.homepageId;

  // Set path
  util.path = body.dataset.path;

  if (util.debugMode) {
    console.info(util.uiCulture, util.uiLanguage, util.homePageId, util.path);
    if (!util.uiCulture) console.error('Culture is not set');
    if (!util.uiLanguage) console.error('Language is not set');
    if (!util.homePageId) console.error('HomePageId is not set');
    if (!util.path) console.error('Path is not set');
  }

  // Enable transitions
  document.documentElement.classList.remove('preloadTransitions');

  app.general.initAppHeight();
  app.cookiePopup.init();
  app.videos.init();

  const min = util.debugMode === false ? '.min' : '';

  if (document.querySelectorAll('[data-toast-message]').length > 0) {
    // show toast messages (with delay)
    const toastMessages = document.querySelectorAll('[data-toast-message]');
    toastMessages.forEach((message, index) => {
      window.setTimeout(() => {
        Toast(message.innerHTML, message.dataset.toastType.toLowerCase(), message.dataset.toastTimeout ?? 7500);
      }, index * 1000);
    });
  }

  // Init dashboard data
  if (document.querySelector('[data-dashboard]')) {
    ljs.load(
      'https://cdnjs.cloudflare.com/ajax/libs/d3/7.8.5/d3.min.js',
      util.getVersionedUrl('/scripts/dist/jsonpath' + min + '.js'),
      util.getVersionedUrl('/scripts/dashboard/modules.dashboard' + min + '.js'),
      () => {
        app.dashboard.init();
      }
    );
  }

  // Init accordions
  if (document.querySelectorAll('[data-accordion-list]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/modules.accordion' + min + '.js'), () => {
      app.accordion.init();
    });
  }

  // Init video lightbox
  if (document.querySelectorAll('[data-video-lightbox]:not([data-video-lightbox-initialized])')) {
    VideoLightbox(document.querySelectorAll('[data-video-lightbox]:not([data-video-lightbox-initialized])'));
  }
});
